import React from 'react';
import { useTranslate } from '../../../lib';
import ButtonYesNo from '../../common/ButtonYesNo';
import { InputNesting } from '../../common/Inputs/Input';

export default function ChatSettings({
  showChatSetting,
  setShowChatSetting,
  channel,
  Tooltip,
  register,
  affectation_time_ref,
  selectedProject,
  percentage_affectation_ref,
  maxUserResponseTime_ref,
  maxUserResponseTime,
  setMaxUserResponseTimeValue,
  bot_respose_time_ref,
  setBot_respose_time,
  gender_bot_avatar_ref,
  genderBotAvatar,
  SelectNesting,
  setSelectedChatOption,
  setShowCustomChatForm,
  customChats,
  showCustomChatForm,
  CustomChat,
  fetchCustomChats
}) {
  const { t } = useTranslate();

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center w-100'>
          <div
            className='w-100'
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowChatSetting(!showChatSetting)} style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }} className='m-0'>
              {t('menu.genai.chatSettings')}
            </h2>

            {!showChatSetting && (
              <button type='button' className='ml-3' onClick={() => setShowChatSetting(true)}>
                <img src='/icons/arrow_down.png' style={{ width: 15 }} alt='' />
              </button>
            )}
            {showChatSetting && (
              <button type='button' className='ml-3' onClick={() => setShowChatSetting(false)}>
                <img src='/icons/arrow_up.png' style={{ width: 15 }} alt='' />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      {showChatSetting && (
        <div
          style={{
            display: showChatSetting ? 'flex' : 'none',
            backgroundColor: '#0088ff09',
            padding: '5px 10px 10px 10px',
            position: 'relative'
          }}
          className='flex-column w-100 pt-5'
        >
          <div className='mt-2 d-flex flex-row flex-wrap align-items-center w-100'>
            <div className="inputs" style={{ marginTop: 10 }}>
              <div className="input d-flex items-center" style={{ height: "auto" }}>
                <div className="input d-flex flex-row align-items-center" style={{ minWidth: 135 }}>
                  <span style={{whiteSpace: "nowrap"}}>{t('menu.resolutionTime')}:</span>
                  <img id="resolution-time-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#resolution-time-tooltip"
                    html={t('menu.resolutionTimeTooltip')} place="top" />
                </div>
                <input {...register('affectation_time', { required: false })}
                  ref={affectation_time_ref} defaultValue={selectedProject.affectation_time} id="affectation_time"
                  type="text" className="input-text ml-1" style={{ maxWidth: 100 }} />
              </div>
            </div>
            <div className="inputs" style={{ marginTop: 10, marginLeft: 10 }}>
              <div className="input d-flex items-center " style={{ height: "auto" }}>
                <div className="input d-flex flex-row align-items-center" style={{ minWidth: 210 }}>
                  <span>{t('menu.percentageOfAffectation')}:</span>
                  <img id="percentage-affectation-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#percentage-affectation-tooltip"
                    html={t('menu.percentageOfAffectationTooltip')} place="top" />
                </div>
                <input {...register('percentage_affectation', { required: false })}
                  ref={percentage_affectation_ref} defaultValue={selectedProject.percentage_affectation} id="percentage_affectation"
                  type="text" className="input-text ml-1" style={{ maxWidth: 100 }} />
              </div>
            </div>
          </div>          

          <div className='mt-2 pb-2 d-flex flex-row flex-wrap align-items-center w-100'>
            <InputNesting
              containerClass="mr-2"
              ref={maxUserResponseTime} id="maxUserResponseTime"
              type="number"
              title={t('menu.genai.maxUserResponseTime')}
              style={{ maxWidth: 100 }}
              onChange={(e) => { setMaxUserResponseTimeValue(e.target.value) }}
            />

            <InputNesting
              ref={bot_respose_time_ref} id="bot_respose_time"
              type="number"
              containerClass="mr-2"
              title={t('menu.genai.replyTime')}
              style={{ maxWidth: 100 }}
              onChange={(e) => { setBot_respose_time(e.target.value) }}
            />
          </div>

          <div style={{ minWidth: 130, display: 'flex', flexDirection: 'row', marginBottom: 15 }}>
            <SelectNesting
              ref={gender_bot_avatar_ref} 
              id="bot_sentiment"
              boxInfo={true} tooltipText={t('menu.genderAvatarTooltip')}
              title={`${t('menu.genderAvatar')}:`} containerClass="" style={{ minWidth: 150 }}
              defaultValue={genderBotAvatar}
            >
              <option value="male" >{t('common.male')}</option>
              <option value="female">{t('common.female')}</option>
            </SelectNesting>
          </div>

          {channel === 'chat' &&
            <div className={`${channel === 'voice' ? 'hidden' : ''} input`} style={{ minWidth: 278, marginBottom: "5px" }}>

              <SelectNesting
                id="custom_chat" className="mt-10px-mb"
                boxInfo={true} tooltipText={t('menu.genai.customChatTooltip')}
                title={`${t('menu.genai.customChat')}:`} containerClass="mr-2"
                onChange={(e) => {
                  const value = e.target.value;
                  //console.log(value);
                  setSelectedChatOption(value === 'new' || value === '' ? '' : value);
                  setShowCustomChatForm(value === 'new');
                }}
              >
                <option value="new">{t('common.new')}</option>
                {customChats.map((item, index) => (
                  <option key={`customchat ${index + 1}`} value={item.id}>{item.name}</option>
                ))}
              </SelectNesting>

              {showCustomChatForm && (
                <CustomChat
                  update={() => { fetchCustomChats() }}
                />
              )}
            </div>}

        </div>
      )}
    </>
  );
}
